

















































































import {
Vue,
Component,
Watch
} from "@/shared/vuepack";
import moment from "moment";
import { FeatureFlags, UserPermission } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useTransferOutStore } from "@/admin/store/transferOut";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({})
export default class TransferOutCampaigns extends Vue {
  isCreating = false;
  allCampaigns = [];
  filterString = "";
  getList = "All";
  sortDirection = 1;
  sortField = "";
  isAscending = true;

  moment = moment;

  get canEbtoUserEdit (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions ?
  this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEbtoEdit)
  || this.userStore.currentUser.groups.some(x => x === "ebto-edit")
  : this.userStore.currentUser.groups.some(x => x === "ebto-edit");
  }

  get isEverythingLoaded () { return this.transferOutStore.isLoaded && this.featureFlagStore.featureFlagsAvailable; }

  userStore = useUserStore();
  transferOutStore = useTransferOutStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  mounted (): void {
    this.transferOutStore.getCampaigns();
    if (this.transferOutStore.CampaignData.campaigns) {
      this.allCampaigns = this.transferOutStore.CampaignData.campaigns;
    }
  }

  filterActiveList (filter: string) {
    this.allCampaigns = [...this.transferOutStore.CampaignData.campaigns];
    if (filter === "active") {
      this.getList = "Active";
      this.allCampaigns = this.allCampaigns.filter(
      campaign => moment(campaign.dateStart).isSameOrBefore()
      && moment(campaign.dateEnd).add(1, "d").isSameOrAfter());
    } else if (filter === "expired") {
      this.getList = "Expired";
      this.allCampaigns = this.allCampaigns.filter(
        campaign => moment(campaign.dateEnd).add(1, "d").isBefore());
    } else {
    this.getList = "All";
    }
  }
  sortCampaigns () {
    if (this.isAscending) {
      this.allCampaigns.sort((a, b) => a[this.sortField] > b[this.sortField] ? 1 : -1);
    } else {
      this.allCampaigns.sort((a, b) => b[this.sortField] > a[this.sortField] ? 1 : -1);
    }
  }
  onSort (key: string): void {
    // Reset the sort direction (Asc or Desc)
    if (this.sortField !== key) {
      this.sortDirection = 1;
      this.isAscending = true;
    } else if (this.sortDirection === 1) {
      this.sortDirection = 2;
      this.isAscending = false;
    } else {
      this.sortDirection = 1;
      this.isAscending = true;
    }
    this.sortField = key;
    this.sortCampaigns();
  }
  @Watch("transferOutStore.CampaignData", { deep: true })
  onCampaignChange () {
    this.allCampaigns = [...this.transferOutStore.CampaignData.campaigns];
  }
  @Watch("filterString", { deep: true })
  onFilterChange (val) {
    if (val.trim().length > 0) {
      const filteredCampaigns = [...this.transferOutStore.CampaignData.campaigns];
      this.allCampaigns = filteredCampaigns.filter(campaign => campaign.name.toLowerCase()
        .includes(val.trim().toLowerCase()) || campaign.employerName.toLowerCase().includes(val.trim().toLowerCase()));
    } else {
      this.allCampaigns = [...this.transferOutStore.CampaignData.campaigns];
    }
  }
  createCampaign (): void {
      this.$router.push("/utility/transfer-out/create-campaign");
  }
}
